import { Loan } from '../types'

const today = new Date()
const addDays = (days: number) => {
  const d = new Date(today)
  d.setDate(d.getDate() + days)
  return d.toISOString()
}

export const mockLoans: Loan[] = [
  {
    id: 'L-1001',
    borrowerName: 'Sarah Jenkins',
    loanName: 'Jenkins Refi',
    loanId: '39281044',
    closingDate: addDays(2),
    loa: 'James Miller',
    processor: 'Amanda Chen',
    loanAmount: 450000,
    lockDate: addDays(-40),
    lockExpiration: addDays(1),
    status: 'Open',
    urgency: 'high',
    notes:
      'Borrower threatening to walk if we do not close by Friday. Appraisal came in low, need retention review immediately.',
  },
  {
    id: 'L-1002',
    borrowerName: 'Michael Chang',
    loanName: 'Chang Purchase',
    loanId: '39281045',
    closingDate: addDays(14),
    loa: 'Taylor Swift',
    processor: 'Marcus Johnson',
    loanAmount: 850000,
    lockDate: addDays(-30),
    lockExpiration: addDays(15),
    status: 'Open',
    urgency: 'medium',
    notes:
      'High loan amount. Borrower is rate shopping with a competitor. Need to review pricing exception.',
  },
  {
    id: 'L-1003',
    borrowerName: 'Robert & Mary Smith',
    loanName: 'Smith HELOC',
    loanId: '39281046',
    closingDate: addDays(5),
    loa: 'Soroki V.',
    processor: 'Eli Vance',
    loanAmount: 150000,
    lockDate: addDays(-20),
    lockExpiration: addDays(2),
    status: 'Open',
    urgency: 'high',
    notes: 'Lock expiring in 48 hours. Missing final VOE.',
  },
  {
    id: 'L-1004',
    borrowerName: 'David Rodriguez',
    loanName: 'Rodriguez Inv',
    loanId: '39281047',
    closingDate: addDays(30),
    loa: 'James Miller',
    processor: 'Amanda Chen',
    loanAmount: 320000,
    lockDate: addDays(-10),
    lockExpiration: addDays(35),
    status: 'Open',
    urgency: 'low',
    notes: 'Standard escalation for DTI review.',
  },
  {
    id: 'L-1005',
    borrowerName: 'Emily Watson',
    loanName: 'Watson Purchase',
    loanId: '39281048',
    closingDate: addDays(3),
    loa: 'Taylor Swift',
    processor: 'Marcus Johnson',
    loanAmount: 620000,
    lockDate: addDays(-42),
    lockExpiration: addDays(3),
    status: 'Open',
    urgency: 'high',
    notes:
      'Closing in 3 days, clear to close not issued. Title issues pending.',
  },
  {
    id: 'L-1006',
    borrowerName: 'James Peterson',
    loanName: 'Peterson Refi',
    loanId: '39281049',
    closingDate: addDays(10),
    loa: 'Soroki V.',
    processor: 'Eli Vance',
    loanAmount: 1250000,
    lockDate: addDays(-25),
    lockExpiration: addDays(20),
    status: 'Open',
    urgency: 'medium',
    notes: 'Jumbo loan. Borrower requested rate match.',
  },
  {
    id: 'L-1007',
    borrowerName: 'Linda Martinez',
    loanName: 'Martinez Purchase',
    loanId: '39281050',
    closingDate: addDays(8),
    loa: 'James Miller',
    processor: 'Amanda Chen',
    loanAmount: 275000,
    lockDate: addDays(-35),
    lockExpiration: addDays(10),
    status: 'Open',
    urgency: 'low',
    notes: 'Escalated by LO for faster underwriting turn time.',
  },
  {
    id: 'L-1008',
    borrowerName: 'William Thompson',
    loanName: 'Thompson Refi',
    loanId: '39281051',
    closingDate: addDays(1),
    loa: 'Taylor Swift',
    processor: 'Marcus Johnson',
    loanAmount: 410000,
    lockDate: addDays(-44),
    lockExpiration: addDays(0),
    status: 'Open',
    urgency: 'high',
    notes:
      'Lock expires TODAY. Closing scheduled for tomorrow. Urgent review required.',
  },
  {
    id: 'L-1009',
    borrowerName: 'Jessica Lee',
    loanName: 'Lee Purchase',
    loanId: '39281052',
    closingDate: addDays(20),
    loa: 'Soroki V.',
    processor: 'Eli Vance',
    loanAmount: 950000,
    lockDate: addDays(-15),
    lockExpiration: addDays(30),
    status: 'Open',
    urgency: 'medium',
    notes:
      'High loan amount. Complex self-employed income calculation dispute.',
  },
  {
    id: 'L-1010',
    borrowerName: 'Thomas Anderson',
    loanName: 'Anderson Refi',
    loanId: '39281053',
    closingDate: addDays(12),
    loa: 'James Miller',
    processor: 'Amanda Chen',
    loanAmount: 540000,
    lockDate: addDays(-28),
    lockExpiration: addDays(17),
    status: 'Open',
    urgency: 'low',
    notes: 'Awaiting subordination agreement from 2nd lien holder.',
  },
  {
    id: 'L-1011',
    borrowerName: 'Christopher White',
    loanName: 'White Purchase',
    loanId: '39281054',
    closingDate: addDays(4),
    loa: 'Taylor Swift',
    processor: 'Marcus Johnson',
    loanAmount: 380000,
    lockDate: addDays(-41),
    lockExpiration: addDays(4),
    status: 'Open',
    urgency: 'high',
    notes: 'Closing in 4 days, lock expires same day. Needs final UW sign off.',
  },
  {
    id: 'L-1012',
    borrowerName: 'Patricia Garcia',
    loanName: 'Garcia Refi',
    loanId: '39281055',
    closingDate: addDays(-2),
    loa: 'Soroki V.',
    processor: 'Eli Vance',
    loanAmount: 290000,
    lockDate: addDays(-47),
    lockExpiration: addDays(-2),
    status: 'Closed',
    urgency: 'low',
    notes: 'Loan closed and funded. Escalation resolved.',
  },
]
